import React from 'react'

export default function EmailContactSubmitMessage({
  serviceType,
  service,
  isError,
}) {
  return (
    <div className="u-sizeConstrained u-marginTop12gu">
      <hr className="Rule u-textColorBrand" />
      <div className="Card u-marginBottom4gu">
        <div className="page-header-title">
          <h2 role="heading">{service.type}</h2>
          {isError ? (
            <p className="u-marginVert3gu">
              Unable to process your request at this time. Please try again
              later
            </p>
          ) : serviceType === 'aqa' || serviceType === 'LC_email' ? (
            <p className="u-marginVert3gu">
              Thank you for your email. We will make every effort to respond to
              your inquiry within two business days, however certain requests
              may take longer. We appreciate your patience.
            </p>
          ) : (
            <>
              <p className="u-marginVert3gu">
                Thank you for your email. You can typically expect a reply from
                us within 2 business days. On rare occasions, you might not
                receive our response due to anti-spam filters.
              </p>
              <p className="u-marginVert3gu">
                If you don&apos;t receive a reply within 2 business days, please
                check your spam or junk email folder or call us at 800.345.6611,
                Monday through Friday, between the hours of 8am - 7pm ET.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
